export const universities = [
  // ── Ivy League ────────────────────────────────────────────────────────────────
  {
    name: "Harvard University", country: "US", type: "Ivy League",
    intensity: 92, style: "Conversational", duration: "30-45 min", color: "#8B0000",
    interviewStyle: "conversational",
    supplementalPrompts: [
      { id: "harvard_diversity", prompt: "Harvard has long recognized the importance of enrolling a diverse student body. How will the life experiences that shape who you are today enable you to contribute to Harvard? (150 words)", wordLimit: 150 },
      { id: "harvard_disagree", prompt: "Describe a time when you strongly disagreed with someone about an idea or issue. How did you engage? What did you learn? (150 words)", wordLimit: 150 },
      { id: "harvard_activities", prompt: "Briefly describe any of your extracurricular activities, employment experience, travel, or family responsibilities that have shaped who you are. (150 words)", wordLimit: 150 },
      { id: "harvard_future", prompt: "How do you hope to use your Harvard education in the future? (150 words)", wordLimit: 150 },
      { id: "harvard_roommate", prompt: "Top 3 things your roommates might like to know about you. (150 words)", wordLimit: 150 },
    ],
  },
  {
    name: "Yale University", country: "US", type: "Ivy League",
    intensity: 86, style: "Intellectual dialogue", duration: "30-45 min", color: "#00356B",
    interviewStyle: "intellectual dialogue",
    supplementalPrompts: [
      { id: "yale_residential", prompt: "Yale's residential colleges create a community that shapes the entire Yale experience. What excites you most about Yale's residential college system? (200 words)", wordLimit: 200 },
      { id: "yale_why", prompt: "What is it about Yale that has led you to apply? (200 words)", wordLimit: 200 },
      { id: "yale_engage", prompt: "Yale students, faculty, and alumni engage with and contribute to the world. Describe how you have taken advantage of an opportunity to engage with the world around you. (200 words)", wordLimit: 200 },
    ],
  },
  {
    name: "Princeton University", country: "US", type: "Ivy League",
    intensity: 80, style: "Structured", duration: "30-45 min", color: "#E77500",
    interviewStyle: "structured conversational",
    supplementalPrompts: [
      { id: "princeton_service", prompt: "Princeton has a longstanding commitment to service. Briefly elaborate on an activity or experience listed on your application that demonstrates your commitment to service to others. (250 words)", wordLimit: 250 },
      { id: "princeton_person", prompt: "Tell us about a person who has had a significant influence on you. (250 words)", wordLimit: 250 },
      { id: "princeton_place", prompt: "Tell us about a place or environment where you have thrived, and why. (250 words)", wordLimit: 250 },
    ],
  },
  {
    name: "Columbia University", country: "US", type: "Ivy League",
    intensity: 74, style: "Analytical", duration: "30-45 min", color: "#002868",
    interviewStyle: "analytical conversational",
    supplementalPrompts: [
      { id: "columbia_texts", prompt: "List a selection of texts, resources, and works of art, music, or other content that you love and that reveal who you are. (200 words)", wordLimit: 200 },
      { id: "columbia_identity", prompt: "A hallmark of the Columbia experience is being able to learn and thrive in an ever-changing, multicultural, and global society. Tell us about an aspect of your background, identity, or experience that is important to who you are. (200 words)", wordLimit: 200 },
      { id: "columbia_why", prompt: "Why are you interested in attending Columbia University? We encourage you to consider the aspect(s) of Columbia that excite you. (200 words)", wordLimit: 200 },
    ],
  },
  {
    name: "University of Pennsylvania", country: "US", type: "Ivy League",
    intensity: 78, style: "Practical", duration: "30-45 min", color: "#990000",
    interviewStyle: "practical and career-focused",
    supplementalPrompts: [
      { id: "penn_academic", prompt: "How will you explore your intellectual and academic interests at the University of Pennsylvania? Please answer this question given the specific undergraduate school to which you are applying. (300 words)", wordLimit: 300 },
      { id: "penn_beyond", prompt: "At Penn, learning and growth happen outside of the classroom too. How will you take advantage of opportunities at Penn outside the classroom? (250 words)", wordLimit: 250 },
    ],
  },
  {
    name: "Brown University", country: "US", type: "Ivy League",
    intensity: 72, style: "Open exploratory", duration: "30-45 min", color: "#4E3629",
    interviewStyle: "open-ended and exploratory",
    supplementalPrompts: [
      { id: "brown_opencurriculum", prompt: "Brown's Open Curriculum allows students to explore broadly while also diving deeply into their academic interests. What do you hope to study at Brown, and how does Brown's Open Curriculum meet your needs as a learner? (250 words)", wordLimit: 250 },
      { id: "brown_care", prompt: "Brown students care deeply about their work and the world around them. What do you care about? (200 words)", wordLimit: 200 },
    ],
  },
  {
    name: "Dartmouth College", country: "US", type: "Ivy League",
    intensity: 75, style: "Community-focused", duration: "30-45 min", color: "#00693E",
    interviewStyle: "warm and community-focused",
    supplementalPrompts: [
      { id: "dartmouth_wrong", prompt: "While arguing a point, you realize that you are wrong. What do you do? (250 words)", wordLimit: 250 },
      { id: "dartmouth_community", prompt: "Labor leader and civil rights activist Dolores Huerta said 'Every moment is an organizing opportunity, every person a potential activist, every minute a chance to change the world.' Describe a meaningful community you have been a part of and what your role was within that community. (250 words)", wordLimit: 250 },
    ],
  },
  {
    name: "Cornell University", country: "US", type: "Ivy League",
    intensity: 70, style: "School-specific", duration: "30-45 min", color: "#B31B1B",
    interviewStyle: "school-specific and practical",
    supplementalPrompts: [
      { id: "cornell_major", prompt: "Why are you drawn to your intended major? How has your background and experience shaped your decision to study this at Cornell? (650 words — varies by college)", wordLimit: 650 },
      { id: "cornell_why", prompt: "Tell us more about why you want to attend Cornell and how it will help you to pursue your goals. (650 words — varies by college)", wordLimit: 650 },
    ],
  },
  // ── Top US Non-Ivy ───────────────────────────────────────────────────────────
  {
    name: "MIT", country: "US", type: "Research University",
    intensity: 88, style: "Technical", duration: "45-60 min", color: "#A31F34",
    interviewStyle: "technical and curious",
    supplementalPrompts: [
      { id: "mit_fun", prompt: "We know you lead a busy life, full of activities, many of which are required of you. Tell us about something you do simply because you find it interesting or fun. (200 words)", wordLimit: 200 },
      { id: "mit_world", prompt: "MIT brings people with diverse backgrounds and experiences together. Describe the world you come from and how it has shaped you and your dreams. (200 words)", wordLimit: 200 },
      { id: "mit_challenge", prompt: "Tell us about the most significant challenge you've faced or something important that didn't go according to plan. How did you manage the situation? (200 words)", wordLimit: 200 },
    ],
  },
  {
    name: "Stanford University", country: "US", type: "Research University",
    intensity: 83, style: "Entrepreneurial", duration: "30-45 min", color: "#8C1515",
    interviewStyle: "exploratory and entrepreneurial",
    supplementalPrompts: [
      { id: "stanford_intellectual", prompt: "Stanford students possess an intellectual vitality. Briefly elaborate on an intellectual experience that was important to you. (250 words)", wordLimit: 250 },
      { id: "stanford_community", prompt: "Virtually all of Stanford's undergraduates live on campus. Tell us about where you have lived and what you hope to bring to your living community at Stanford. (250 words)", wordLimit: 250 },
      { id: "stanford_meaningful", prompt: "Tell us about something that is meaningful to you and why. (250 words)", wordLimit: 250 },
    ],
  },
  {
    name: "Duke University", country: "US", type: "Research University",
    intensity: 70, style: "Collaborative", duration: "30-45 min", color: "#003087",
    interviewStyle: "balanced and collaborative",
    supplementalPrompts: [
      { id: "duke_why", prompt: "What is your sense of Duke as a university and why do you consider it a good match for you? If there's a specific aspect of Duke's academics, research, campus life, or community that most excites you, feel free to share it. (250 words)", wordLimit: 250 },
      { id: "duke_diversity", prompt: "Duke's commitment to diversity and inclusion includes sexual orientation, gender identity, and gender expression. Tell us about an aspect of your identity that you'd like to bring to Duke's campus community. (250 words)", wordLimit: 250 },
    ],
  },
  {
    name: "Northwestern University", country: "US", type: "Research University",
    intensity: 76, style: "Career-focused", duration: "30-45 min", color: "#4E2A84",
    interviewStyle: "structured and career-aware",
    supplementalPrompts: [
      { id: "northwestern_quarter", prompt: "Northwestern's distinctive quarter system allows students to engage with a wide breadth of topics. How will you take advantage of the quarter system in pursuit of your academic interests? (250 words)", wordLimit: 250 },
      { id: "northwestern_community", prompt: "Northwestern fosters a sense of community throughout the university's many schools, departments, and activities. Briefly describe a community to which you have meaningfully contributed and what your involvement has meant to both you and the community. (250 words)", wordLimit: 250 },
    ],
  },
  {
    name: "Johns Hopkins University", country: "US", type: "Research University",
    intensity: 75, style: "Research-focused", duration: "30-45 min", color: "#002D72",
    interviewStyle: "research-focused and pre-professional",
    supplementalPrompts: [
      { id: "jhu_life", prompt: "Briefly tell us about a life experience that has been particularly important to your development. (400 words)", wordLimit: 400 },
    ],
  },
  {
    name: "Georgetown University", country: "US", type: "Research University",
    intensity: 72, style: "Values-driven", duration: "30-45 min", color: "#041E42",
    interviewStyle: "values-driven and service-focused",
    supplementalPrompts: [
      { id: "georgetown_jesuit", prompt: "Georgetown is a Jesuit Catholic university, and its mission emphasizes the importance of becoming 'people for others.' Tell us about an experience that illustrates what this means to you. (Approx. 1 page)", wordLimit: 500 },
      { id: "georgetown_diversity", prompt: "What does it mean to you to be a part of a diverse community? How will you contribute to Georgetown's culturally rich and diverse environment? (Approx. 1 page)", wordLimit: 500 },
    ],
  },
  {
    name: "Rice University", country: "US", type: "Research University",
    intensity: 70, style: "Community", duration: "30-45 min", color: "#003087",
    interviewStyle: "community-focused and personal",
    supplementalPrompts: [
      { id: "rice_qualities", prompt: "The quality of Rice's academic life and the residential college system depend on the meaningful participation of each student. What are the unique qualities or characteristics you will bring to Rice? (150 words)", wordLimit: 150 },
      { id: "rice_challenge", prompt: "Describe a challenge you have faced and the steps you have taken to overcome it. (250 words)", wordLimit: 250 },
    ],
  },
  {
    name: "Vanderbilt University", country: "US", type: "Research University",
    intensity: 68, style: "Well-rounded", duration: "30-45 min", color: "#866D4B",
    interviewStyle: "warm and well-rounded",
    supplementalPrompts: [
      { id: "vanderbilt_why", prompt: "Vanderbilt University offers a rigorous academic environment, a thriving community, and an abundance of opportunities for personal and professional growth. Why are you applying to Vanderbilt and how do you see yourself contributing to our community? (250 words)", wordLimit: 250 },
    ],
  },
  {
    name: "Notre Dame", country: "US", type: "Research University",
    intensity: 67, style: "Values and faith", duration: "30-45 min", color: "#0C2340",
    interviewStyle: "values and faith-integrated",
    supplementalPrompts: [
      { id: "notredame_mission", prompt: "Notre Dame was founded by the Congregation of Holy Cross, whose motto is, 'Ave Crux, Spes Unica' — 'Hail the Cross, our only hope.' If you were admitted to Notre Dame, how might the particular traditions, values, or spirit of the University enhance your undergraduate experience? (200 words)", wordLimit: 200 },
    ],
  },
  {
    name: "Carnegie Mellon University", country: "US", type: "Research University",
    intensity: 80, style: "Technical/creative", duration: "30-45 min", color: "#C41230",
    interviewStyle: "technical and project-focused",
    supplementalPrompts: [
      { id: "cmu_major", prompt: "Most students choose their intended major or area of study based on a passion or strength. Briefly tell us more about why you want to pursue your intended field of study and how it connects to your future goals. (300 words)", wordLimit: 300 },
    ],
  },
  {
    name: "University of Chicago", country: "US", type: "Research University",
    intensity: 84, style: "Intellectual intense", duration: "30-45 min", color: "#800000",
    interviewStyle: "intellectually intense and quirky",
    supplementalPrompts: [
      { id: "uchicago_essay", prompt: "UChicago's Extended Essay: respond to one of the University of Chicago's essay prompts. These change annually and are famously unconventional. (650 words)", wordLimit: 650 },
      { id: "uchicago_why", prompt: "How does the University of Chicago, as you know it, satisfy your desire for a particular kind of learning, community, and future? Please address with some specificity your own wishes and how they relate to UChicago. (250 words)", wordLimit: 250 },
    ],
  },
  {
    name: "Washington University in St. Louis", country: "US", type: "Research University",
    intensity: 72, style: "Interdisciplinary", duration: "30-45 min", color: "#A51417",
    interviewStyle: "well-rounded and community-focused",
    supplementalPrompts: [
      { id: "wustl_community", prompt: "Tell us about a community or group that you are a part of. What is your role in that community, and what has that role taught you about yourself? (250 words)", wordLimit: 250 },
    ],
  },
  {
    name: "Emory University", country: "US", type: "Research University",
    intensity: 65, style: "Service and health", duration: "30-45 min", color: "#012169",
    interviewStyle: "service-oriented and health-focused",
    supplementalPrompts: [
      { id: "emory_activity", prompt: "Tell us about a meaningful extracurricular activity, work experience, or service that has been important to your development. (150 words)", wordLimit: 150 },
      { id: "emory_why", prompt: "What aspects of Emory University's college or school are you most excited to explore, and why? (150 words)", wordLimit: 150 },
    ],
  },
  {
    name: "Tufts University", country: "US", type: "Research University",
    intensity: 68, style: "Civic-minded", duration: "30-45 min", color: "#3E8EDE",
    interviewStyle: "global and civic-minded",
    supplementalPrompts: [
      { id: "tufts_why", prompt: "Which aspects of Tufts' curriculum or undergraduate experience prompt your application? In short, 'Why Tufts?' (200 words)", wordLimit: 200 },
      { id: "tufts_world", prompt: "SMFA at Tufts: Tell us about a time when you had to translate something difficult into a language the other person could understand, whether literal or metaphorical. (200 words)", wordLimit: 200 },
    ],
  },
  {
    name: "Boston College", country: "US", type: "Research University",
    intensity: 65, style: "Jesuit values", duration: "30-45 min", color: "#8B0000",
    interviewStyle: "Jesuit and service-oriented",
    supplementalPrompts: [
      { id: "bc_contribute", prompt: "Boston College strives to provide an undergraduate learning experience emphasizing the liberal arts, quality teaching, personal formation, and engagement of critical issues. Tell us how you see yourself contributing to and benefiting from BC's unique learning community. (400 words)", wordLimit: 400 },
    ],
  },
  {
    name: "Brandeis University", country: "US", type: "Research University",
    intensity: 62, style: "Social justice", duration: "30-45 min", color: "#003878",
    interviewStyle: "social justice oriented",
    supplementalPrompts: [
      { id: "brandeis_why", prompt: "Why are you applying to Brandeis University? How does Brandeis match your academic interests and personal values? (250 words)", wordLimit: 250 },
      { id: "brandeis_justice", prompt: "Brandeis was founded on ideals of social justice, non-sectarianism, and respect for all. How have you engaged with issues of social justice or equity in your community? (250 words)", wordLimit: 250 },
    ],
  },
  {
    name: "Case Western Reserve University", country: "US", type: "Research University",
    intensity: 68, style: "Research/STEM", duration: "30-45 min", color: "#0A304E",
    interviewStyle: "research and STEM focused",
    supplementalPrompts: [
      { id: "cwru_why", prompt: "In our results-oriented culture, failure is often seen negatively. But many great innovations and discoveries came from a 'failed' idea. Tell us about a time that failure ultimately helped you succeed. (500 words)", wordLimit: 500 },
      { id: "cwru_research", prompt: "Which program or academic opportunity at Case Western Reserve are you most excited to explore, and why? Be specific. (250 words)", wordLimit: 250 },
    ],
  },
  {
    name: "Wake Forest University", country: "US", type: "Research University",
    intensity: 65, style: "Pro humanitate", duration: "30-45 min", color: "#9E7E38",
    interviewStyle: "pro humanitate and well-rounded",
    supplementalPrompts: [
      { id: "wfu_challenge", prompt: "Wake Forest's motto is 'Pro Humanitate' (For Humanity). Tell us about a time you had a positive impact on your community or used your skills to help others. (250 words)", wordLimit: 250 },
      { id: "wfu_why", prompt: "Why are you interested in Wake Forest, and what makes you a good fit for our community? (250 words)", wordLimit: 250 },
    ],
  },
  {
    name: "Lehigh University", country: "US", type: "Research University",
    intensity: 62, style: "Engineering/business", duration: "30-45 min", color: "#6B3A2A",
    interviewStyle: "engineering and business focused",
    supplementalPrompts: [
      { id: "lehigh_why", prompt: "Tell us about your specific academic interests and how studying at Lehigh will help you pursue them. Why Lehigh? (250 words)", wordLimit: 250 },
      { id: "lehigh_outside", prompt: "Describe how you will contribute to Lehigh's community beyond your academic work. (250 words)", wordLimit: 250 },
    ],
  },
  {
    name: "University of Rochester", country: "US", type: "Research University",
    intensity: 65, style: "Academic freedom", duration: "30-45 min", color: "#003B79",
    interviewStyle: "Take 5 and Renaissance focused",
    supplementalPrompts: [
      { id: "rochester_community", prompt: "The University of Rochester has an 'Ever Better' spirit. Tell us about something you have done to make your community, school, or world 'ever better.' (250 words)", wordLimit: 250 },
      { id: "rochester_curious", prompt: "Tell us something about yourself that you think would be valuable for us to know but that is not reflected elsewhere in your application. (250 words)", wordLimit: 250 },
    ],
  },
  {
    name: "Tulane University", country: "US", type: "Research University",
    intensity: 60, style: "Service/New Orleans", duration: "30-45 min", color: "#006940",
    interviewStyle: "community service and New Orleans culture",
    supplementalPrompts: [
      { id: "tulane_why", prompt: "Please describe why you are interested in attending Tulane University. (250 words)", wordLimit: 250 },
      { id: "tulane_service", prompt: "Tulane is a recognized leader in service learning and civic engagement. How has community service or civic engagement shaped your life, and how will you contribute to Tulane's culture of service? (250 words)", wordLimit: 250 },
    ],
  },
  // ── UK Universities ──────────────────────────────────────────────────────────
  {
    name: "University of Oxford", country: "UK", type: "Ancient University",
    intensity: 95, style: "Tutorial interrogation", duration: "2-3 interviews × 30-40 min each", color: "#002147",
    subjectMode: true,
    interviewStyle: "Academic tutorial interrogation",
    supplementalPrompts: [
      { id: "oxford_personal", prompt: "Oxford does not have supplemental essays — your UCAS Personal Statement is your primary written submission. Paste your UCAS Personal Statement here so we can personalise your interview practice. (4000 characters)", wordLimit: 700 },
    ],
  },
  {
    name: "University of Cambridge", country: "UK", type: "Ancient University",
    intensity: 95, style: "Tutorial rigour", duration: "1 interview × 25-35 min", color: "#003B5C",
    subjectMode: true,
    interviewStyle: "Academic tutorial interrogation",
    supplementalPrompts: [
      { id: "cambridge_personal", prompt: "Cambridge does not have supplemental essays — your UCAS Personal Statement is your primary written submission. Paste your UCAS Personal Statement here for personalised interview practice. (4000 characters)", wordLimit: 700 },
    ],
  },
  {
    name: "Imperial College London", country: "UK", type: "Research University",
    intensity: 88, style: "Technical/scientific", duration: "20-40 min", color: "#003E74",
    subjectMode: true,
    interviewStyle: "Technical faculty panel",
    supplementalPrompts: [
      { id: "imperial_personal", prompt: "Imperial does not have supplemental essays — your UCAS Personal Statement is your primary written submission. Paste your UCAS Personal Statement here for personalised interview practice. (4000 characters)", wordLimit: 700 },
    ],
  },
];

export const getUniversityNames = () => universities.map(u => u.name);

export const getUSUniversities = () => universities.filter(u => u.country === "US");

export const getUKUniversities = () => universities.filter(u => u.country === "UK");

export const getUniversityByName = (name) => universities.find(u => u.name === name);

// ─── Backward-compat exports ────────────────────────────────────────────────

export const UNIVERSITIES = universities;

export const UNIVERSITY_NAMES = universities.map(u => u.name);

export function getUniversity(name) {
  return universities.find(u => u.name === name) || { name, interviewStyle: 'conversational', duration: "30-45 min", supplementalPrompts: [] };
}
